import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useSpeakerMediaDeviceStore = defineStore('speaker-media-device', () => {
  const isTestStarted = ref(false)
  const volume = ref(0.5)
  const isSpeakersMuted = ref(false)

  const testSpeakers = (audioElement: HTMLAudioElement | undefined) => {
    if (!audioElement) return
    if (isTestStarted.value) {
      audioElement.pause()
      isTestStarted.value = false
    } else {
      audioElement.play()
      isTestStarted.value = true
    }
  }

  return {
    isTestStarted,
    volume,
    isSpeakersMuted,
    testSpeakers,
  }
})
